/*
 * @Description: In User Settings Edit
 * @Author: caoshuyun
 * @Date: 2020-11-12 20:21:19
 * @LastEditTime: 2019-08-20 15:31:28
 * @LastEditors: Please set LastEditors
 */
const api = {}
api.login = '/api/web/user/login'; // 登陆
api.code = '/api/web/user/getCode'; // 获取短信验证码
api.resetPwd = '/api/web/user/resetpwd'; //重置密码
api.index = '/api/web/index/indexSum'; //首页数据汇总
api.shopData = '/api/web/index/shopData';
api.tradeDay = '/api/web/index/tradeDay';


api.shopPageList = '/api/web/shop/getList'; //店铺数据
api.shopDetail = '/api/web/shop/detail'; //
api.shopAllList = '/api/web/shop/getAllList';
api.shopUpdate = '/api/web/shop/update'; //
api.staffList = '/api/web/staff/getList'; //
api.deviceList = '/api/web/device/getList'; //
api.doDevice = '/api/web/device/doDevice'; //
api.lockList = '/api/web/lock/getList'; //
api.doLock = '/api/web/lock/doDevice'; //
api.bookOrderList = '/api/web/order/getList'; //
api.chargeOrderList = '/api/web/charge/getList'; //
api.tuanOrderList = '/api/web/tuan/getList'; //

api.mtOrderList = '/api/web/Mt/getList'; //
api.dyOrderList = '/api/web/Dou/getList'; //

api.roomList = '/api/web/room/getList'; //
api.userList = '/api/web/user/getList'; //
api.joinList = '/api/web/user/joinList'; //

api.cardList = '/api/web/user/userCardList'; //
api.withList = '/api/web/shop/withList'; //
api.getCityList = '/api/web/shop/getCityList'; //
api.updateWithStatus = '/api/web/shop/updateWithStatus'; //

api.tradeList = '/api/web/trade/getList'; //
api.updateJoinStatus = '/api/web/user/updateJoinStatus'; //
api.doLockBind = '/api/web/lock/doBind'; //
api.addBalance = '/api/web/shop/addBalance';
api.balanceList = '/api/web/shop/balanceList';
api.countExportTrade = '/api/web/trade/countExportTrade';
api.orderExportTrade = '/api/web/trade/orderExportTrade';




export default api



// WEBPACK FOOTER //
// ./src/config/api.js